export enum NavigationListNames {
    MAIN = 'main navigation',
    HOMEPAGE = 'home',
    SEARCH = 'search',
    PRODUCT_RECOMMENDATION = 'product recommendation',
    CONTENTFUL = 'contentful',
}

export enum NavigationListTypes {
    STANDARD_PDP = 'standard pdp',
    STANDARD_PLP = 'standard plp',
    HOMEPAGE = 'home',
    SEARCH = 'search',
    PRODUCT_RECOMMENDATION = 'product recommendation',
    CONTENTFUL = 'product carousel',
}
